import { render, staticRenderFns } from "./CRMDashboard.vue?vue&type=template&id=5bbca95e&scoped=true"
import script from "./CRMDashboard.vue?vue&type=script&lang=js"
export * from "./CRMDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbca95e",
  null
  
)

export default component.exports